module.exports = __webpack_public_path__ + "static/media/beezchat.c82e8f0e.png";